import { Users, Compass, Disc3, Handshake } from "lucide-react";
import { Reveal } from "./Reveal";

const VINYL_URL =
  "https://images.unsplash.com/photo-1526394931762-90052e97b376?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHx2aW55bCUyMHJlY29yZHMlMjBhZXN0aGV0aWN8ZW58MHx8fHwxNzg2OTg2NjgzfDA&ixlib=rb-4.1.0&q=85";

const services = [
  {
    icon: Disc3,
    title: "Label & Publishing Strategy",
    testId: "service-card-label-strategy",
    copy: "Thirty years of relationships with labels and publishers, put to work on your side of the negotiation — from first conversations to signed paper.",
  },
  {
    icon: Handshake,
    title: "Brand & Music Partnerships",
    testId: "service-card-brand-partnerships",
    copy: "Over 2 decades working on music initiatives for Red Bull, helping the brand build authentic music programs, artist partnerships, live events, and content that audiences actually care about.",
  },
  {
    icon: Compass,
    title: "Career Consulting",
    testId: "service-card-consulting",
    copy: "Honest, experienced counsel for artists and songwriters at a crossroads — deals on the table, teams in flux, or a plan that needs sharpening.",
  },
  {
    icon: Users,
    title: "Artist Management",
    testId: "service-card-management",
    copy: "Day-to-day direction for working artists: touring, releases, team building, and the thousand small decisions that add up to a career.",
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="border-t border-border bg-muted/40">
    <div className="mx-auto max-w-6xl px-6 py-24 sm:py-32">
      <Reveal>
        <p className="text-xs font-medium tracking-[0.35em] uppercase text-foreground/60">
          Services
        </p>
        <h2 className="mt-6 max-w-xl font-serif text-3xl font-normal tracking-tight sm:text-4xl">
          Quiet counsel for loud careers.
        </h2>
      </Reveal>
      <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        {services.map((service, i) => (
          <Reveal key={service.title} delay={0.1 * i} className={i % 2 === 1 ? "lg:translate-y-8" : ""}>
            <div
              data-testid={service.testId}
              className="group h-full border border-border bg-background p-10 transition-colors duration-300 hover:border-foreground/40"
            >
              <service.icon
                className="h-8 w-8 text-foreground/70 transition-colors duration-300 group-hover:text-foreground"
                strokeWidth={1.25}
              />
              <h3 className="mt-8 font-serif text-2xl font-medium sm:text-3xl">
                {service.title}
              </h3>
              <p className="mt-4 text-sm leading-relaxed text-foreground/70">
                {service.copy}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2} className="mt-20">
        <div className="relative">
          <div className="absolute -right-4 -top-4 h-full w-full border border-border" />
          <img
            src={VINYL_URL}
            alt="A vinyl record on a turntable"
            data-testid="services-image"
            className="relative h-64 w-full border border-foreground/20 object-cover sm:h-80"
          />
        </div>
      </Reveal>
    </div>
  </section>
);
